import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageTable, Header } from "/src/layouts/page";
import Table from "/src/components/table";
import "./UserTable.css";
import userServiceForAdmins from "../../services/userService";
import storage from "/src/utils/storage";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";
import UserHttpLogsTable from "../../../logs/components/ApiLogsTable/UserHttpLogsTable";
import SliderTab from "/src/components/slider/sliderTab/SliderTab";

function UserHistoryTable(data) {
    const currentUser = storage("local").get("user");
    const { getHistories } = userServiceForAdmins;
    const navigate = useNavigate();
    const userData = data.data;
    const extractBrowser = (userAgent) => {
        const browserRegex = /(?:Firefox|Chrome|Safari|Opera|MSIE|Trident)\/(?:[0-9]+\.)+[0-9]+/;
        const matches = userAgent.match(browserRegex);
        return matches ? matches[0] : "Unknown";
    };

    const extractPlatform = (userAgent) => {
        const platformRegex =
            /(Windows NT \d+\.\d+|Windows Phone \d+\.\d+|Windows CE|Linux \w*(?=;)|Linux armv\d+|Macintosh|Mac OS X \d+(_\d+)?|Android \d+(\.\d+)?|CrOS|X11|Ubuntu|Debian|Fedora|Red Hat|SuSE|iOS|iPhone|iPad|FreeBSD|OpenBSD|NetBSD|SunOS|BlackBerry\d+)/;
        const matches = userAgent.match(platformRegex);
        return matches ? matches[0] : "Unknown";
    };

    const LoginHistoryTable = () => (
        <Table
            name="user login history"
            cells={cells}
            api={(params) => getHistories(userData?.id, params)}
            actions={actions}
            buttons={buttons}
            filters={filters}
        />
    );

    const getItems = () => [
        { name: "Connexions", component: <LoginHistoryTable />, type: 0 },
        { name: "API Logs", component: <UserHttpLogsTable userId={userData?.id} />, type: 1 },
    ];

    const [items] = useState(getItems());

    useEffect(() => {
        if (!userData) {
            navigate("/administration/user/list");
        }
    }, [userData, navigate]);

    var cells = [];
    if (currentUser.is_admin) {
        cells = [
            {
                column: "Connexion",
                name: "created_at",
                sort: true,
                show: (value) => formatDateWithoutSeconds(value, true),
            },

            {
                column: "Ip Address",
                name: "ip_address",
                show: (value) => value,
            },
            {
                column: "Browser",
                name: "user_agent",
                show: (value) => extractBrowser(value),
            },
            {
                column: "Platform",
                name: "user_agent",
                sort: true,
                show: (value) => extractPlatform(value),
            },
        ];
    } else {
        cells = [
            {
                column: "AVATAR",
                name: "picture",
                show: (value) => <img srcSet={value}></img>,
            },
            {
                column: "USERNAME",
                name: "username",
                show: (value) => value,
            },
            {
                column: "EMAIL",
                name: "email",
                show: (value) => value,
            },
        ];
    }

    var actions = [];

    const buttons = [];

    const filters = [];

    return (
        <PageTable>
            <Header title={`Login History of ${userData?.username}`}></Header>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>
            <SliderTab items={items} name="user-history" type="table" />
        </PageTable>
    );
}

export default UserHistoryTable;
